module.exports = __webpack_public_path__ + "img/surveillance.acd58aea.jpg";